module.exports = __webpack_public_path__ + "img/character-14.369fd2fe.png";